import type { EokoMunicipality } from '@/types'
import LoadingBox from '@/components/loading-box'
import ErrorBox from '@/components/error-box'
import { useEokoMunicipalities } from '@/hooks/api/use-municipality'

interface EokoMunicipalitiesLoaderProps {
    children: (data: Array<EokoMunicipality> ) => React.ReactNode
    privateList?: boolean
}

const EokoMunicipalitiesLoader: React.FC<EokoMunicipalitiesLoaderProps> = ({
    children,
}) => {

    const { status, data, error } = useEokoMunicipalities()

    if (status === 'pending') {
        return <LoadingBox />
    }

    if (error) {
        return <ErrorBox
            error={error}
            message={'Nepovedlo se načíst obce z EOKA'}
        />
    }


    if (data.length > 0) {
        return <>{children(data)}</>
    }

    return null
}

export default EokoMunicipalitiesLoader
